// extracted by mini-css-extract-plugin
export default {"button":"Button_button__tgA6J","secondary":"Button_secondary__rRur3"};